var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    [
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "24", label: "购物车", name: "preSale" } },
            [
              _c(
                "div",
                { staticClass: "global-tool-bar" },
                [
                  _c("PreSaleOrderList", {
                    ref: "preSaleOrderList",
                    model: {
                      value: _vm.preSale,
                      callback: function ($$v) {
                        _vm.preSale = $$v
                      },
                      expression: "preSale",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }